// TODO: check
enum SortableGroups {
  ACTION_LIST = 'ACTION_LIST',
  BLOCK_LIST = 'BLOCK_LIST',
  MENU_ITEM_BLOCK_LIST = 'MENU_ITEM_BLOCK_LIST',
  FILE_SYSTEM_OBJECT_LIST = 'FILE_SYSTEM_OBJECT_LIST',
  CARD_ELEMENT_LIST = 'CARD_ELEMENT_LIST',
  CONTENT_ITEM_LIST = 'CONTENT_ITEM_LIST',
  BUTTON_LIST = 'BUTTON_LIST',
  CONDITION_LIST = 'CONDITION_LIST',
  TEMPLATE_DRAFT_FIELD_LIST = 'TEMPLATE_DRAFT_FIELD_LIST',
}

export default SortableGroups
